import { applicationError, getCompanyIdFromDomain } from "../../utils";
import { getAnalytics } from "firebase/analytics";
import { deleteApp, FirebaseApp, getApp, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getCompanyFirebaseCredentials } from "../backend";
import { DELIVERY_FLEET_CONFIGURATION_TYPE } from "../../constants";

let firebaseModule: FirebaseApp;
let firebaseFleet: FirebaseApp;
let analytics;

export const getFirebaseAuth = () =>
  firebaseModule ? getAuth(firebaseModule) : undefined;
export const getFirebaseFleet = () => firebaseFleet;
export const getFirebaseModule = () => firebaseModule;

//----------------------------------------
// FIREBASE INIT
//----------------------------------------
export const initializeFirebase = async () => {
  // GET COMPANY FROM DOMAIN
  let companyId = getCompanyIdFromDomain();
  let firebaseCredentials: any;
  try {
    firebaseCredentials = await getCompanyFirebaseCredentials(companyId);
  } catch (err) {
    if (err.code === 404) {
      firebaseCredentials = await getCompanyFirebaseCredentials("dishop-dev");
      companyId = "dishop-dev";
    } else throw err;
  }
  try {
    const configFleet = firebaseCredentials?.fleet;
    const configForCompany = firebaseCredentials[companyId];
    companyId = configForCompany.companyId;
    const initializeFirebaseApps = () => {
      firebaseModule = initializeApp(configForCompany, "module");
      firebaseFleet = initializeApp(
        configFleet,
        DELIVERY_FLEET_CONFIGURATION_TYPE.FLEET
      );
      analytics = getAnalytics(firebaseModule);
    };
    try {
      initializeFirebaseApps();
    } catch (error) {
      // deleteApp(getApp(DELIVERY_FLEET_CONFIGURATION_TYPE.FLEET));
      // deleteApp(getApp('module'));
      // initializeFirebaseApps();
    }

    return companyId;
  } catch (err) {
    applicationError("Error getting firebase credentials", {
      err,
      firebaseCredentials,
    });
  }
};
export { analytics };
